<template>
  <div class="it-header-slim-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="it-header-slim-wrapper-content">
            <a class="d-none d-lg-block navbar-brand" href="#">CIRSFID, ALMA MATER STUDIORUM - Università di Bologna</a>
            <div class="nav-mobile">
              <nav>
                <a class="it-opener d-lg-none" data-toggle="collapse" href="#menu4" role="button" aria-expanded="false" aria-controls="menu4">
                  ALMA MATER STUDIORUM - Università di Bologna - CIRSFID
                  <svg class="icon">
                    <use :xlink:href="icons.itExpand"></use>
                  </svg>
                </a>
                <div class="link-list-wrapper collapse" id="menu4">
                  <ul class="link-list">
                    <li><a href="http://www.cirsfid.unibo.it/" target="_blank">Sito Cirsfid</a></li>
                    <li><a href="https://www.cortecostituzionale.it/default.do" target="_blank">Sito Corte Costituzionale</a></li>
                  </ul>
                </div>
              </nav>
            </div>
            <div class="header-slim-right-zone">
              <div class="nav-item dropdown">
                <a aria-expanded="false" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">
                  <span>ITA</span>
                  <svg class="icon icon-white d-none d-lg-block">
                    <use :xlink:href="icons.itExpand"></use>
                  </svg>
                </a>
                <div class="dropdown-menu">
                  <div class="row">
                    <div class="col-12">
                      <div class="link-list-wrapper">
                        <ul class="link-list">
                          <li>
                            <a class="list-item" href="#"><span>ITA</span></a>
                          </li>
                          <li>
                            <a class="list-item" href="#"><span>ENG</span></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a class="btn btn-primary btn-icon btn-full" href="#" title="Accedi all'area personale">
                <span class="rounded-icon">
                  <svg class="icon icon-primary">
                    <use :xlink:href="icons.itUser"></use>
                  </svg>
                </span>
                <span class="d-none d-lg-block">Accedi all'area personale</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'HeaderMain',
  data() {
    return {
      icons: {
        itExpand: `${sprites}#it-expand`,
        itUser: `${sprites}#it-user`,
      },
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderTop.vue